module.exports = __webpack_public_path__ + "img/list.2924d3ca.svg";